<template>
    
  <div class="MyMission">
      <my-header :title="title" :platform="platform"></my-header>
    <!-- <div class="task-ban" ref="taskBan">
      <van-swipe :loop="true"  class="swiper" :show-indicators="false" >
        <van-swipe-item @click="goCard(item)" class="task-ban-item" v-for="(item,index) in bannerList" :key="index">
            <img :src="item.imgUrl"/>
        </van-swipe-item>
      </van-swipe>
    </div> -->
    <div class="task-con">
        <img @click="notice" style="width: 100%;display: block;" :src="`/static/mymission/task-ban${taskId}.jpg`" alt="">
      <!-- <div class="mm_tab flex_sb" :style="fixedIs?'position:fixed;':'position:inherit;'"> -->
      <div class="mm_tab flex_sb">
        <div
          class="mm_tabitem"
          :class="tab_active_index == index ? 'active' : ''"
          v-for="(item, index) in tablist"
          :key="index"
          :data-index="index + 1"
          @click="change_tab"
        >
          {{ item }}
        </div>
        <img
          src="/static/mymission/btn_jiangli.png"
          class="btn_jiangli"
          @click="href_reward"
        />
      </div>
      <!-- <div class="mm-tab-padd"></div> -->
      <!-- 打卡列表 -->
      <!-- <div class="mm_list" :style="fixedIs?'padding-top:80px;':'padding-top:10px;'"> -->
      <div class="mm_list">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
        >
          <div
            v-for="(item, index) in mm_list"
            :key="index"
            class="mm_liitem "
            @click="href_detail($event)"
            :data-id="item.taskId"
            :data-title="item.taskTitle"
          >
            <div class="flex_sb">
                <img :src="item.taskImageUrl" class="img_left" />
                <div class="title">{{ item.taskTitle }}</div>
                <div
                class="mm_btn"
                v-if="item.taskState == 1"
                :class="item.isUploadImg == 0 ? 'mm_isup' : ''"
                >
                    <div class="btn1" >
                        {{ item.isUploadImg == 0 ? "本周已完成" : "上传打卡" }}
                    </div>
                </div>
                <div class="mm_img" v-else>
                    <img :src="'/static/mymission/status' + item.taskState + '.png'" />
                </div>
            </div>
            
            <div class="mml_center">
              <div class="desc" v-html="item.taskDesc"></div>
              <div class="time" v-if="item.taskState == 1">
                截止时间：{{ item.taskEndTime }}
              </div>
              <div class="time" v-else-if="item.taskState == 2">
                开始时间：{{ item.taskBeginTime }}
              </div>
              <div class="time" v-else-if="item.taskState == 3">
                获得次数：{{ item.thisGiveCourseNum }}次
              </div>
              <div class="time" v-else-if="item.taskState == 4">
                获得次数：{{
                  item.thisGiveCourseNum + "/" + item.maxGiveCourseNum + "次"
                }}
              </div>
            </div>
            
          </div>
        </van-list>
      </div>
      <div class="upload-toast" v-if="tab_active_index==0">
          上传图片支持jpg、jpeg、bmp、png格式
      </div>
      <div class="upload-padd"></div>
      <!-- 重要提醒 -->
      <!-- <div class="notice" @click="notice">
        <img src="/static/mymission/notice.png" />
      </div> -->
      <!--打卡tanchuag   -->
      <div class="window rule_w" style="display:none;">
        <div class="w_content">
          <p class="p1">1、分享任务的完成方式，包括以下几种：</p>
          <p class="p2">
            （1）WeChat朋友圈发出“推荐考拉知道的注册图片/ 链接+文字”；<br />
            （2）100人以上的WeChat群内发出“推荐考拉知道的注册图片/链接+文字”；<br />
            （3）在Facebook个人页面发出“推荐考拉知道的注册图片/链接+文字”；<br />
            （4）在YouTube上发出“推荐考拉知道的注册图片/链接+文字”；<br />
            （5）在Twitter上发出“推荐考拉知道的注册图片/链接+文字”；<br />
            （6）在论坛上发出“推荐考拉知道的注册图片/链接+文字”；<br />
            （7）发布的图文不得分组或删除。
          </p>
          <p class="p1">
            2、上传的打卡凭证须符合第1条“推荐考拉知道的注册图片/链接+文字”的基本内容要求，否则视为无效打卡。考拉知道将对所有上传图片进行人工审核，如发现打卡凭证未满足前述规则，则相应赠送内容将被扣回，且当期不得补传。
          </p>
          <div class="back" @click="click_back">知道了</div>
        </div>
      </div>
    </div>
    <Login
      :code_list="code_list"
      hide_warn="yes"
      v-if="login_s"
      @register="register"
      @close="hide_win"
      @havelogin="havelogin"
    />
    <Register
      :code_list="code_list"
      :fromuid="fromuid"
      hide_warn="yes"
      appid="公众号内功能注册"
      v-if="register_s"
      @login="login"
      @close="hide_win"
      @haveregister="haveregister"
    />
  </div>
</template>
<script>
import { List, Cell,Swipe,SwipeItem } from "vant";
import http from "../../../service/http";
import Login from "../common/login/login";
import Register from "../common/register/register";
import MyHeader from "../common/MyHeader/MyHeader"

export default {
  name: "MyMission",
  components: {
    [List.name]: List,
    [Cell.name]: Cell,
    [Swipe.name]:Swipe,
    [SwipeItem.name]: SwipeItem,
    Login,
    Register,
    MyHeader
  },
  data() {
    return {
      tablist: ["进行中", "未开始", "已完成", "已过期"], //tab列表数据（固定数据）
      tab_active_index: 0, //处于选中状态tab的序号
      userinfo: {}, //用户的基本信息
      loading: false,
      finished: false, //是否已加载完成
      taskState: 1, //当前对应任务状态任务状态 1=进行中 2=未开始 3=已完成 4=已过期
      page: 1, //当前列表页码
      ajaxurl: "https://apinew.koalaknow.com/api/OfficialWebSite/InterfaceV1",

      code_list: [], //国家区号列表
      login_s: false, //展示登录
      register_s: false, //展示注册
      mm_list: [], //当前页面列表
      fromuid: "", //来源id
      fixedIs:false,
      bannerList:[],//banner
      title:'',
      platform:'',
      taskId:1,
      infiniteScroll:true
    };
  },
  created() {
    document.title=this.title = this.$route.query.title||"上传截图";
    this.platform=this.$route.query.platform||''

  },
  mounted() {
    let that=this
    var userinfo = localStorage.getItem("userinfo")
    that.userinfo=JSON.parse(userinfo);
    if(this.$route.query.taskId){
        this.taskId=this.$route.query.taskId
        this.onLoad()
        // this.getBannerList()
        this.TaskListCount()
    }else{
      if(http.getQueryString("guid")){
        that.getusersmall_uid(http.getQueryString("guid"));
      }else{
        this.getopenid();
      }
    }
    
    
    window.addEventListener("scroll", function () {
        let scrollTtop=window.pageYOffset 
        that.$nextTick(()=>{
            if(scrollTtop>80){
            that.fixedIs=true
            }else{
            that.fixedIs=false
            }
        })
        const scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
        const windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
        const scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
        if(scrollTop+windowHeight >= scrollHeight){
            //到了这个就可以进行业务逻辑加载后台数据了
            // console.log("到了底部");
            console.log(that.finished);
            if(!that.finished){
                that.onLoad()
            }
        } 
    })

  },
  
  methods: {
    //获取用户openid
    getopenid() {
      if (http.getQueryString("openid")) {
        this.LoadInit(http.getQueryString("openid"));
      } else {
        var msg = "https%3a%2f%2fwww.koalaknow.com%2fMobile%2fIntermediary";
        window.location.href =
          "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx3d92e9bbedce149e&redirect_uri=" +
          msg +
          "&response_type=code&scope=snsapi_base&state=123#wechat_redirect";
      }
    },
    LoadInit(openID) {
      var that=this;
      $.ajax({
        type: "POST",
        url: "https://www.koalaknow.com/Personal_MyClASS_Do/GetUserOpenID",
        data: { openID: openID },
        success: function (msg) {
          if (msg != "-1") {
            // that.getuser();
            that.getusersmall_uid(msg);
          } else {
            that.getuser();
          }
        },
      });
    },
    //获取用户短id
    getusersmall_uid(guid){
      var url="https://apinew.koalaknow.com/api/AlumniAssociationRequestHandle/InterfaceV1";
      var data={
        cmd:'GetUserInfoByGuid',
        userGuid:guid
      },
      that=this;
      http.req(data,(res)=>{
        localStorage.setItem("userinfo", JSON.stringify(res.info));
        var userinfo = localStorage.getItem("userinfo")
        that.userinfo=JSON.parse(userinfo);
        that.getBannerList()
        setTimeout(()=>{
          that.havelogin();
        },500)
      },url)
    },
    //展示window
    notice() {
      // $(".rule_w").show();
      window.location.href='/MyMissionRule?taskId='+this.$route.query.taskId+'&platform='+this.platform
      // window.location.href='https://www.koalaknow.com/img/guize.pdf'
    },
    //隐藏window
    click_back() {
      $(".rule_w").hide();
    },
    //获取用户登录状态
    getuser() {
      var userinfo = localStorage.getItem("userinfo"),
        that = this;
        userinfo=JSON.parse(userinfo)
        // console.log(userinfo,'user')
      var imgUrl = "https://www.koalaknow.com/img/VcharImg/vcharlogo.png"; // 分享图标
      var title = "为孩子报名",
        desc = "专业老师，专属课程，爱上“动起来”的中文";
      if (!userinfo) {
        http.get_codelist((res) => {
          that.code_list = res.list;
          that.login_s = true;
        });
        if(http.getQueryString("openid")){
          http.wxshare(
            "",
            "https://official.koalaknow.com/MyMission",
            title,
            desc,
            imgUrl
          );
        }
        
      } else {
        this.userinfo = userinfo;
        if(http.getQueryString("openid")){
          http.wxshare(
            userinfo.userId,
            "https://official.koalaknow.com/MyMission?uid=" +
              userinfo.userId,
            title,
            desc,
            imgUrl
          );
        }
        this.TaskListCount();
      }
      if (http.getQueryString("uid")) {
        this.fromuid = http.getQueryString("uid");
        console.log(this.fromuid);
      }
    },
    onLoad() {
       var userinfo = localStorage.getItem("userinfo")
        userinfo=JSON.parse(userinfo);
        console.log(userinfo)
      if (userinfo&&userinfo.userGuid) {
        var data = {
            cmd: "GetUserTaskListByPage",
            userGuid: userinfo.userGuid,
            taskState: this.taskState,
            page: this.page,
            pageSize: 10,
            taskTypeId:this.$route.query.taskId,
          },
          that = this;

        that.page = that.page + 1;
        http.req(
          data,
          function (res) {
            if (res.list.length > 0) {
              that.mm_list = that.mm_list.concat(res.list);
              that.loading = false;
            } 
            if(res.list.length<10){
              that.finished = true;
            }
          },
          this.ajaxurl
        );
      }
    },
    //获取当前各个打卡任务任务数量
    TaskListCount() {
      var data = {
          cmd: "GetUserTaskListCount",
          userGuid: this.userinfo.userGuid,
          taskTypeId:this.$route.query.taskId,
        },
        that = this;
        http.req(
          data,
          (res) => {
            that.tablist = [
              "进行中(" + res.enyJinXingZhong + ")",
              "未开始(" + res.enyWeiKaiShi + ")",
              "已完成(" + res.enyYiWanCheng + ")",
              "已过期(" + res.enyYiGuoQi + ")",
            ];
          },
          this.ajaxurl
        );
    },
    //点击去查看奖励页面
    href_reward() {
      if (this.userinfo) {
        window.location.href = "/MyReward?platform="+this.platform;
      } else {
        that.login_s = true;
      }
    },
    //点击去任务详情
    href_detail(e) {
      var title = e.currentTarget.dataset.title;
      var taskid = e.currentTarget.dataset.id;
      window.location.href =
        "/MyMissionDetail?title=" + title + "&id=" + taskid+"&platform="+this.platform;
    },
    //切换tab
    change_tab(e) {
      var index = e.target.dataset.index;
      this.taskState = index;
      this.tab_active_index = index - 1;
      this.page = 1;
      this.loading = true;
      this.finished = false;
      this.mm_list = [];
      this.onLoad();
    },
    //点击去注册
    register(e) {
      this.login_s = false;
      this.register_s = true;
    },
    //去登陆
    login() {
      this.login_s = true;
      this.register_s = false;
    },
    //登录成功
    havelogin() {
      this.login_s = false;
      this.register_s = false;
      this.getuser();
      this.onLoad();
    },
    //注册成功
    haveregister() {
      this.login_s = false;
      this.register_s = false;
      this.getuser();
      this.onLoad();
    },
    hide_win() {},
    // 去星座卡
    goCard(item){
      window.location.href=item.imgParam
      // this.$router.push({path:'/card',query:{guid:this.userinfo.userGuid}})
    },
    // 获取banner
    getBannerList(){
      let url='https://apinew.koalaknow.com/api/AlumniAssociationRequestHandle/InterfaceV1'//正式
      // let url='https://apinewtest.koalaknow.com/api/AlumniAssociationRequestHandle/InterfaceV1'//测试
      let data={
          cmd: "GetBannerListByCategory",
          userGuid: this.userinfo.userGuid,
          bannerCategory:"enyWDRW_WX",
      }
      http.req(data,(res)=>{
        this.bannerList=res.list
      },url)
    },
  },
};
</script>
<style scoped>

.w_content {
  background: #fff;
  width: 80%;
  border-radius: 10px;
  padding: 30px 30px 10px;
  box-shadow: border-box;
  font-size: 24px;
  line-height: 42px;
}
.w_content .p1 {
  font-weight: bold;
}
.w_content .p2 {
  color: #666;
}
.w_content .back {
  width: 200px;
  height: 70px;
  background: #e0382d;
  border-radius: 44px;
  color: #fff;
  text-align: center;
  line-height: 70px;
  margin: 30px auto;
}
.MyMission {
  min-height: 100vh;
  background: #f4f4f4;
}
.mm_tab {
  height: 80px;
  background: #ffffff;
  color: #333333;
  font-size: 28px;
  line-height: 80px;
  padding: 0 0 0 30px;
  box-sizing: border-box;
  /* position: fixed; */
  /* top: 0; */
  z-index: 2;
  width: 100%;
}
.mm-tab-padd{
  height: 80px;
}
.mm_tab .mm_tabitem {
  padding: 0 10px;
  box-sizing: border-box;
}
.mm_tab .active {
  border-bottom: 4px solid #ff2424;
  box-sizing: border-box;
}
.mm_tab .btn_jiangli {
  width: 96px;
  height: 80px;
  margin: 0;
}
.mm_list {
  padding: 30px;
  box-sizing: border-box;
}
.mm_list .mm_liitem {
  padding: 30px;
  box-sizing: border-box;
    box-shadow: 0px 5px 8px 0px rgba(180, 180, 180, 0.2);
  border-radius: 20px;
  background: #fff;
  margin-bottom: 20px;
  position: relative;
}

.mm_list .img_left {
  width: 60px;
  height: 60px;
  margin-right: 20px;
  flex-shrink: 0;
  -webkit-flex-shrink: 0;
}
.mm_list .title{
    flex: 1;
    font-size: 30px;
    font-weight: bold;
    color: #222222;
    text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.mm_list .mm_btn {
    min-width: 150px;
    height: 60px;
    border-radius: 30px;
  background: #F43737;
  color: #fff;
  font-size: 24px;
  font-weight: 400;
  /* line-height: 100px; */
  flex-shrink: 0;
  -webkit-flex-shrink: 0;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  margin-left: 30px;
}
.mm_list .mm_isup {
  background: #EEEEEE;
  color: #999999;
  height: 60px;
  border-radius: 30px;
}
.mm_list .mml_center {
  flex: 1;
  -webkit-flex: 1;
}
.mm_list .mml_center .desc {
  margin: 16px 0 12px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.mm_list .mml_center .time,
.mm_list .mml_center .desc {
  color: #666;
  font-size: 24px;
  line-height: 31px;
}
.mm_list .mm_img {
  width: 181px;
}
.mm_list .mm_img img {
  width: 148px;
  position: absolute;
  top: 50%;
  right: 21px;
  transform: translateY(-50%);
}
.notice {
  position: fixed;
  right: 30px;
  bottom: 100px;
}
.notice img {
  width: 214px;
}
.task-ban-item img{
  display: block;
  width: 100%;
  height: 382px;
}

.task-entrance{
  padding: 29px 12px;
}
.task-entrance img{
  width: 100%;
  display: block;
  margin-bottom: 6px;
}
.upload-padd{
    height: 80px;
}
.upload-toast{
    width: 100%;
    height: 80px;
    line-height: 80px;
    text-align: center;
    position: fixed;
    left: 0;
    bottom: 0;
    background-color: #FFFFFF;
    font-size: 24px;
    font-weight: 400;
    color: #999999;
}
</style>



// WEBPACK FOOTER //
// src/components/content/MyMissionList.vue